import { useMemo } from 'react';
import { object, string, number, ObjectSchema } from 'yup';
import { useTranslation } from 'react-i18next';
import { STRING_MIN_LENGTH_DEFAULT } from '@cbridge-utils/app';
import { CSV_SAFE_REGEX } from '@cbridge-utils/shared-helpers';
import { IStreamForm } from '@cbridge-packages/stream';

export const useStreamFormSchema = (): ObjectSchema<IStreamForm> => {
  const { t } = useTranslation();

  return useMemo(() => {
    return object({
      streamId: number(),
      nodeId: number().label(t('text:entity.symbolPool.nodeName.label')).required(),
      name: string()
        .trim()
        .label(t('text:entity.markupStream.name.label'))
        .min(STRING_MIN_LENGTH_DEFAULT)
        .max(128)
        .matches(CSV_SAFE_REGEX, t('text:validation.chars.csvUnsafe'))
        .required(),
      markupProfileId: number()
        .transform((value) => value ?? undefined)
        .notRequired(),
    });
  }, [t]);
};
